export default class Newsfeed {
	static init() {
		/**********************
		 * Dölj bilder på desktop för artiklar i nyhetsflödet där bara en av dem har bild
		 */
		var defaultGrids = document.querySelectorAll('.o-newsfeed__defaultGrid');

		defaultGrids.forEach(function (grid) {
			// Get all col-12 col-md-6 elements within this grid
			var colPairs = grid.querySelectorAll('.col-12.col-md-6');

			// Loop through each pair
			for (var i = 0; i < colPairs.length; i += 2) {
				var col1 = colPairs[i];
				var col2 = colPairs[i + 1];

				// Check if both columns have m-card__media elements
				var hasMedia1 = col1.querySelector('.m-card__media') !== null;
				var hasMedia2 = col2.querySelector('.m-card__media') !== null;

				// If only one column has a m-card__media element, add a class to hide images
				if ((hasMedia1 && !hasMedia2) || (!hasMedia1 && hasMedia2)) {
					col1.classList.add('hide-images');
					col2.classList.add('hide-images');
				}
			}
		});

		// For accessibility
		// Get the first defaultGrid
		var firstDefaultGrid = document.querySelector('.o-newsfeed__defaultGrid');

		// If defaultGrid exists
		if (firstDefaultGrid) {
			// Get the first m-card__content within this grid
			var firstCardContent = firstDefaultGrid.querySelector('.m-card__content');

			// If m-card__content exists, add an id to it
			if (firstCardContent) {
				firstCardContent.id = 'page-content';
			}
		}
	}
}
